import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LungCancerPage from "./pages/LungCancerPage";
import BreastCancerPage from "./pages/BreastCancerPage";
import CervixCancerPage from "./pages/CervixCancerPage";
import ColonCancerPage from "./pages/ColonCancerPage";
import EpidermisCancerPage from "./pages/EpidermisCancerPage";
import EsophagusCancerPage from "./pages/EsophagusCancerPage";
import KidneyCancerPage from "./pages/KidneyCancerPage";
import PancreaticCancerPage from "./pages/PancreaticCancerPage";
import ProfilePage from "./pages/ProfilePage";
import AnalyticsPage from "./pages/AnalyticsPage";
import SettingsPage from "./pages/SettingsPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import ScanHistoryPage from "./pages/ScanHistoryPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import EmailPendingPage from "./pages/EmailPendingPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import OtpVerifyPage from "./pages/OtpVerifyPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
        <Routes>
          {/* Public auth routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/email-pending" element={<EmailPendingPage />} />
          <Route path="/verify-otp" element={<OtpVerifyPage />} />
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path="/admin-dashboard" element={<AdminDashboardPage />} />

          {/* Protected app with sidebar + navbar layout */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/lung-cancer" replace />} />
            <Route path="/lung-cancer" element={<LungCancerPage />} />
            <Route path="/breast-cancer" element={<BreastCancerPage />} />
            <Route path="/cervix-cancer" element={<CervixCancerPage />} />
            <Route path="/colon-cancer" element={<ColonCancerPage />} />
            <Route path="/epidermis-cancer" element={<EpidermisCancerPage />} />
            <Route path="/esophagus-cancer" element={<EsophagusCancerPage />} />
            <Route path="/kidney-cancer" element={<KidneyCancerPage />} />
            <Route path="/pancreatic-cancer" element={<PancreaticCancerPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/scan-history" element={<ScanHistoryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/lung-cancer" replace />} />
        </Routes>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
